<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";
  
  </script>
  
  <Card>
  <CardBody>
    <!-- <div class="mb-4 h1 card-title">Notice</div> -->
    
        <img
          src="assets/images/klaid-challenge-poster.jpg"
          alt=""
          class="img-thumbnail mx-auto d-block"
        />
      
  </CardBody>
  </Card>
  
  